module.exports = __webpack_public_path__ + "static/media/fun-card-badge.74b409e5.webp";